import React from 'react'
import { Button as ButtonBS } from 'react-bootstrap'

import { OBJECT_OBJECT } from '../../../../../store/Settings/sets'


export default function ({
    settings = {},
    stateKey,
    fields,
    saveSettings,
    disabled,
}) {

    return (
        <div className="SettingsObjectVideoSave spp-btns">
            <ButtonBS
                variant="primary"
                disabled={disabled}
                onClick={() => saveSettings({
                    type: OBJECT_OBJECT,
                    stateKey,
                    fields,
                })}
            >
                {settings.saving === true ? "Сохранение..." : "Сохранить"}
            </ButtonBS>
        </div>
    )
}